<template>
    <h2 class="d-inline">{{ $trans.get('__JSON__.Reviews') }}
        <div class="pt-1 pb-1 ps-2 pe-2 bg-danger text-white rounded-1 badge" style="font-size: 0.7rem; transform: translateY(-0.7rem);">
        {{ getCountReviews() }} </div> </h2>
    <table class="table table-striped hover-zoom">
        <thead>
            <tr>
            <th role="button" @click.prevent="sortColumn = 'employee'">
                {{ $trans.get('__JSON__.Employee') }}
                <i v-if="sortColumn == 'employee'" class="fa fa-sort-asc"></i>
            </th>
            <th role="button" @click.prevent="sortColumn = 'team'">
                {{ $trans.get('__JSON__.Team') }}
                <i v-if="sortColumn == 'team'" class="fa fa-sort-asc"></i>
            </th>
            <th role="button" @click.prevent="sortColumn = 'type'">
                {{ $trans.get('__JSON__.Type') }}
                <i v-if="sortColumn == 'type'" class="fa fa-sort-asc"></i>
            </th>
            <th role="button" @click.prevent="sortColumn = 'created_at'">
                {{ $trans.get('__JSON__.review created at') }}
                <i v-if="sortColumn == 'created_at'" class="fa fa-sort-asc"></i>
            </th>
            <th role="button" @click.prevent="sortColumn = 'tl'">
                TL
                <i v-if="sortColumn == 'tl'" class="fa fa-sort-asc"></i>
            </th>
            <th role="button" @click.prevent="sortColumn = 'responsible'">
                {{ $trans.get('__JSON__.Responsible') }}
                <i v-if="sortColumn == 'responsible'" class="fa fa-sort-asc"></i>
            </th>
            <th>
                {{ $trans.get('__JSON__.Action') }}
            </th>
            </tr>   
        </thead>
        <tbody>
            <tr v-for="review in sortedReviews" :key="'et-' + review.id">
                <td>
                     {{ makeFullname(review.employee.lastname, review.employee.forename) }}
                </td>
                <td>
                    {{ review.team?.name }}
                </td>
                <td>
                    {{ $trans.get('__JSON__.' + review.reviewtype.name) }}
                </td>
                <td>
                    <i v-if="isYesterdayOrBefore(review.created_at)" class="fa fa-warning text-danger"
                        v-tooltip title="Warnung älter als ein Tag!"></i>&nbsp;
                    {{ toYMDHMFormat(review.created_at) }}
                </td>
                <td>
                    <i v-if="review.role_id && review.teamready" class="fas fa-dot-circle text-success" data-toggle="tooltip"
                        title="Team review finished"></i>
                    <i v-if="review.role_id && !review.teamready" class="fas fa-dot-circle text-danger" data-toggle="tooltip"
                        title="Team review not finished yet"></i>
                </td>
                <td>
                    <i v-if="monitor_others && review.role_id"> OperationsManager </i>
                    <i v-if="monitor_others && review.team_id"> TeamLead </i>
                </td>
                <td>
                    <a class="btn btn-secondary" href="" @click.prevent="goToReviewEdit(review.id)">
                        {{ $trans.get('__JSON__.Edit') }}</a>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import axios from "axios";
import getReviews from "../composables/getReviews";
import getEmployees from "../composables/getEmployees";

export default {

    name: "Reviews",

    props: {
        monitor_others: Boolean,
        view_locations: Object,
    },
    setup(props) {
        const { reviews, review_error, loadReviews} = getReviews();
        loadReviews(props.monitor_others, props.view_locations);
        const { employees, employees_error, loadEmployees } = getEmployees();
        loadEmployees(null, [
            null
        ]);

        return { reviews, review_error, loadReviews, loadEmployees };
    },
    data() {
        return {
            sortColumn: 'created_at',
            counted: null,
            employee: null,
        };
    },
    created() {
        let refreshtime =  600000 + Math.floor(Math.random() * 120000);
        setInterval(this.refreshData,refreshtime)
    },
    computed: {

        sortedReviews() {
            // Div im Blade verstecken, wenn es keine BEMs gibt.
            if (!this.reviews) {
                $('#reviewsContainer').css('display', 'none');
                return null;
            }

            if (this.reviews.length == 0) {
                $('#reviewsContainer').css('display', 'none');
                return null;
            }

            $('#reviewsContainer').css('display', 'block');
            return this.reviews.sort(this.compareReviews);
        }
    },
    methods: {
        formatDate(dateString) { // mm.d.yyyy

            if (dateString == null) {
                return null;
            }
            const date = new Date(dateString);

            return date.toLocaleDateString().slice(0, 10) + ', ' + date.toLocaleTimeString();
        },
        toYMDFormat(dateString) { // yyyy-mm-dd
            if (dateString == null) {
                return null;
            }
            var date = new Date(dateString);
            var mm = date.getMonth()+1;
            mm = mm.toString().padStart(2, '0');
            var yyyy = date.getFullYear();
            var dd = date.getDate().toString().padStart(2, '0');

            var formattedDate = yyyy + '-' + mm + '-' + dd

            return formattedDate

        },
        toYMDHMFormat(dateString) { // yyyy-mm-dd hh:mi
            if (dateString == null) {
                return null;
            }
            var date = new Date(dateString);
            var mm = date.getMonth()+1;
            mm = mm.toString().padStart(2, '0');
            var yyyy = date.getFullYear();
            var dd = date.getDate().toString().padStart(2, '0');
            var hh = date.getHours().toString().padStart(2, '0');
            var mi = date.getMinutes().toString().padStart(2, '0');

            var formattedDate = yyyy + '-' + mm + '-' + dd + ' ' + hh + ':' + mi

            return formattedDate

        },
        compareReviews(a, b) {
            if (this.sortColumn == 'start_at') {

                if (a.start_at == b.start_at) {
                    return 0;
                }

                if (a.start_at < b.start_at) {
                    return -1;
                }
                return 1;
            }

            if (this.sortColumn == 'end_at') {

                if (a.end_at == b.end_at) {
                    return 0;
                }

                if (a.end_at < b.end_at) {
                    return -1;
                }
                return 1;
            }

            if (this.sortColumn == 'day') {

                if (a.day == b.day) {
                    return 0;
                }

                if (a.day < b.day) {
                    return -1;
                }

            }

            if (this.sortColumn == 'team') {

                if (a.employee.team_id == b.employee.team_id) {
                    return 0;
                }

                if (a.employee.team_id < b.employee.team_id) {
                    return -1;
                }
            }

            if (this.sortColumn == 'location') {

                if (a.employee.location.id == b.employee.location.id) {
                    return 0;
                }

                if (a.employee.location.id < b.employee.location.id) {
                    return -1;
                }

            }
            

            if (this.sortColumn == 'employee') {
                if (a.employee.lastname > b.employee.lastname) {
                    return 1;
                }

                if (a.employee.lastname < b.employee.lastname) {
                    return -1;
                }

                if (a.employee.forename > b.employee.forename) {
                    return 1;
                }

                if (a.employee.forename < b.employee.forename) {
                    return -1;
                }

                if (a.start_at > b.start_at) {
                    return 1;
                }

                if (a.start_at < b.start_at) {
                    return -1;
                }

                return 0;
            }

            return 0;
        },
        getCountReviews() {
            if (!this.sortedReviews) {
                return counted = 0;
            }
            let counted = this.sortedReviews.length;
            return counted;
        },
        isYesterdayOrBefore(date) {
            var d = new Date();
            d.setDate(d.getDate() - 1);
            if (Date.parse(date) <= Date.parse(d)) {
                return true;
            }
            return false;
        },
        isOlderThanFourDays(date) {
            var d = new Date();
            d.setDate(d.getDate() - 4);
            if (Date.parse(date) < Date.parse(d)) {
                return true;
            }
            return false;
        },
        putReview(review) {
            this.setExternalOuttime(review);

            this.review = this.review.filter(function (value, index, arr) {
                return value.id != review.id;
            });
        },
        makeFullname(lastname, forename) {
            const fullname = lastname + ', ' + forename;
            return fullname;
        },
        goToReviewEdit(review_id) {
            let myNewPathname = "reviews/" + review_id + "/edit";
            window.location.pathname = myNewPathname;
        },
        refreshData() {
            this.loadReviews(this.monitor_others, this.view_locations);
        },

    }
}



</script>